import { IWidgetContext } from '../../context/WidgetContext';
import { WindowApp, WindowConfig } from '../../shared/types';

const generateAppsMap = (apps: Array<WindowApp>): IWidgetContext['apps'] =>
  apps.reduce((acc, curr) => {
    acc[curr.slug] = curr;
    return acc;
  }, {} as IWidgetContext['apps']);

const windowConfigToWidgetContext = (
  windowConfig: WindowConfig,
  hostPageParams?: any,
): IWidgetContext => {
  const { accountId, apps, logo, style, positions, appearances } = windowConfig;

  return {
    hostPageParams,
    isDefaultConfig: windowConfig.isDefaultConfig ?? false,
    accountId,
    positions,
    appearances,
    logo,
    styleConfig: style,
    highlighted:
      apps.find(({ highlighted }) => highlighted === true) ?? apps[0],
    apps: generateAppsMap(apps),
  };
};
export default windowConfigToWidgetContext;
